import { useTheme } from "@emotion/react";

type Props = {
  count: number;
  backgroundColor?: string;
  color?: string;
  withShadow?: boolean;
};

const maxDisplayedCount = 99;

export const countBadgeLabel = (count: number): string =>
  count > maxDisplayedCount ? `${maxDisplayedCount}+` : `${count}`;

export const NotificationCountBadge: React.FC<Props> = ({
  count,
  backgroundColor = "white",
  color,
  withShadow = backgroundColor === "white",
}) => {
  const theme = useTheme();

  return (
    <div
      css={{
        minWidth: "15px",
        height: "15px",
        padding: "0 3px",
        backgroundColor,
        borderRadius: "999px",
        boxShadow: withShadow ? "0px 4px 4px rgba(0,0,0,0.25)" : undefined,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: color ?? theme.colors.primary,
        fontSize: "10px",
        fontWeight: 900,
      }}
    >
      {countBadgeLabel(count)}
    </div>
  );
};
